import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, Heart, Shield, Users, Compass, Star, Globe, Award, CheckCircle } from 'lucide-react';

export default function SolutionPage() {
  return (
    <div className="min-h-screen py-24 md:py-32 bg-background" data-testid="solution-page">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-sm font-medium tracking-wider uppercase text-secondary mb-3 block">Notre approche</span>
          <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4">La solution M-CareLink</h1>
          <p className="text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Un guichet unique de coordination pour des séjours de répit sécurisés, adaptés et sereins.
          </p>
        </div>

        {/* Piliers */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16">
          {[
            { icon: Shield, title: "Hébergements vérifiés", desc: "Chaque établissement partenaire est évalué selon des critères stricts d'accessibilité PMR, de confort et de qualité de service. Nous vérifions les installations, les équipements et la capacité d'accueil adaptée." },
            { icon: Heart, title: "Accompagnement humain", desc: "Des auxiliaires de vie et professionnels de l'accompagnement qualifiés sont mobilisés selon vos besoins spécifiques. Nous assurons la coordination avec vos intervenants habituels pour préparer la continuité d'accompagnement." },
            { icon: Compass, title: "Coordination globale", desc: "Un interlocuteur unique pilote l'ensemble de votre séjour : transport adapté, hébergement, assistance, matériel médical, activités de loisirs. Vous n'avez plus à tout organiser seul." },
            { icon: Star, title: "Suivi de bout en bout", desc: "Avant, pendant et après le séjour, nous restons à vos côtés. Préparation minutieuse, suivi en temps réel, bilan de satisfaction : chaque étape est maîtrisée." }
          ].map(({ icon: Icon, title, desc }) => (
            <div key={title} className="bg-white rounded-2xl p-8 border border-border/30 shadow-sm hover:shadow-md transition-all duration-300">
              <div className="w-12 h-12 rounded-xl bg-secondary/10 flex items-center justify-center mb-5">
                <Icon className="w-6 h-6 text-secondary" />
              </div>
              <h3 className="font-heading text-xl font-semibold text-foreground mb-3">{title}</h3>
              <p className="text-muted-foreground leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>

        {/* Why M-CareLink */}
        <div className="bg-white rounded-3xl p-8 md:p-12 border border-border/30 shadow-sm mb-16">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground mb-6 text-center">Pourquoi M-CareLink ?</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              "Un seul interlocuteur pour tout coordonner",
              "Des partenaires évalués sur des critères objectifs",
              "Une approche centrée sur la dignité et le respect",
              "La préparation de la continuité d'accompagnement",
              "Une logistique porte-à-porte intégrée",
              "Un suivi qualité systématique"
            ].map((text, i) => (
              <div key={i} className="flex items-start gap-3 py-2">
                <CheckCircle className="w-5 h-5 text-secondary flex-shrink-0 mt-0.5" />
                <p className="text-foreground">{text}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center">
          <Link to="/demander-un-sejour">
            <Button className="rounded-full bg-accent text-accent-foreground px-8 py-6 text-lg font-semibold hover:bg-accent/90 hover:scale-105 transition-all shadow-lg" data-testid="solution-cta">
              Demander un séjour <ArrowRight className="ml-2 w-5 h-5" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
